// angular
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';
import { AppService } from '../../../app.service';
import { MeAppointmentService } from '../appointment.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../../../core/auth.service';
import { KlenicoMeService } from '../../me.service';
import { Subscription } from 'rxjs';
import { DialogComponent } from '../../../dialog/dialog.component';

@Component({
    selector: 'me-appointment-booking-page',
    templateUrl: './booking-page.component.html',
    styleUrls: ['./booking-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MeAppointmentService]
})

export class MeAppointmentBookingPageComponent implements OnInit, AfterViewInit, OnDestroy {
    data: any;
    url = 'appointment/booking-page';
    showCalendar = false;
    bookingUrl;
    therapistData = {};
    language = 1;
    languages = [];
    cituroId = '';
    subcription: Subscription;
    isAgree = 0;

    @ViewChild('dialog', { static: true }) dialog: DialogComponent;

    constructor(
        public translate: TranslateService,
        public appService: AppService,
        public coreService: CoreService,
        public route: ActivatedRoute,
        public router: Router,
        public authService: AuthService,
        public meAppointmentService: MeAppointmentService,
        public meService : KlenicoMeService,
        public sanitizer:DomSanitizer
    ) {
       
    }

    ngOnInit() {
        this.getBookingCard();
        this.language = this.authService.user.language_id;

        this.subcription = this.translate.onLangChange.subscribe(res => {
            this.getBookingCard();
        });


        window.addEventListener(
            'message',
            e => this.createBooking(e)
        );

        this.route.params.subscribe(params => {
            this.cituroId = params['cituroId'];
            this.meAppointmentService.getTherapistStoryBlok(this.cituroId).subscribe(res => {
                this.therapistData = res['stories'][0]['content'];
            });

            this.meAppointmentService.getTherapistById(this.cituroId).subscribe(res => {
                this.languages = res['data'];
                this.language = res['language'];
                this.bookingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.generateBookingUrl());
            });
        });
    }

    ngOnDestroy() {
        window.removeEventListener(
            'message',
            e => this.createBooking(e)
        );
        this.subcription.unsubscribe();
    }

    ngAfterViewInit() {
        this.coreService.className = 'me-landing-page';
        this.meService.isNonMedicalFooter = true;
    }

    getBookingCard() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content'] ?? [];
            this.data = contents;
            this.appService.isLoading = false;
        });
    }

    selectTherapist() {
        this.router.navigate(['me/appointment']);
    }

    updateCituroLink() {
        this.bookingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.generateBookingUrl());
    }

    confirm() {
        this.showCalendar = true;
    }

    generateBookingUrl() {
        // Move me to global
        let url = 'https://app.cituro.com/booking/9445577?';
        let params = {
            'firstName' : this.authService.user.given_name,
            'lastName' : this.authService.user.surname,
            'email' : this.authService.user.email
        };

        url = url + '&presetFields=' + encodeURIComponent(JSON.stringify(params));

        if (this.cituroId && this.cituroId !== '') {
            url = url + '&presetResource=' + this.cituroId;
        }

        let presetService = '';
        this.languages.forEach(lang => {
            if (lang.id == this.language) {
                presetService = lang['cituroServiceId'];
            } 
        });

        if (presetService == '') {
            presetService = this.languages[0]['cituroServiceId'];
        }

        let locale = 'de';
        this.appService.meLanguages.forEach(meLanguage => {
            if (meLanguage.id === this.language) {
                locale = meLanguage.locale.toLocaleLowerCase();
            }
        });

        url = url + '&presetService=' + presetService + '&locale=' + locale;
        return url;
    }

    createBooking(e) {
        if(e.data.event && e.data.event.source == 'cituro'){
            if(e.data.event.type == 'onBookingCompleted'){
                const bookingId = e.data.event.data.booking.eventId;
                this.appService.isLoading = true;
                this.meAppointmentService.createBooking(bookingId).subscribe(res => {
                    this.appService.isLoading = false;
                    this.router.navigate(['me/dashboard']);
                },
                error => {
                    this.appService.isLoading = false;
                    let dialog = this.dialog.openAlert({
                        icon: 'fas fa-exclamation-triangle',
                        warning: true,
                        content: error.error.error,
                        cancelText : 'OK',
                    });
    
                    dialog.onCancel(() => {
                        this.router.navigate(['me/appointment']);
                    });
                }
            );
            }
        }
    }
}
